<template>
  <div
    v-if="!loaded || count > 0"
    :class="container"
  >
    <div class="card">
      <div class="d-block card-body">
        <div class="h5 font-weight-bold mb-2 text-body d-block mb-3">
          {{ title }}
        </div>
        <i
          v-if="!loaded && loading"
          class="fa fa-spin fa-circle-notch text-muted"
        ></i>
        <ul class="list-unstyled">
          <li
            v-for="(guide, index) in guides"
            :key="index"
            class="my-1"
          >
            <a :href="urls.support.showGuide(guide.id)">
              {{ guide.title }}
            </a>
            <span
              v-if="showPublishedDate"
              class="small text-muted ml-1"
            >
              {{ createdAt(guide.created_at) }}
            </span>
            <span
              v-if="showMostPopularCount"
              class="small text-muted ml-1"
            >
              {{ guide.most_popular }} people
            </span>
          </li>
        </ul>
        <hr v-if="hasMore">
        <div class="d-flex small">
          <button
            v-if="hasMore"
            class="btn btn-sm btn-outline-flat-wisteria ml-auto align-self-center"
            :disabled="loading"
            @click="loadMore"
          >
            <span v-if="loading">
              <i class="fa fa-fw fa-circle-o-notch fa-spin text-muted"></i>
            </span>
            <span v-else>
              More
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import { getGuides } from '@/api'
  import urls from '@/api/urls'
  import { formatDate } from '@/lib/moment'

  export default {
    props: {
      container: {
        type: String,
        default: null
      },
      title: {
        type: String,
        default: ''
      },
      filter: {
        type: String,
        default: 'newest'
      },
      user: {
        type: Boolean,
        default: false
      },
      showPublishedDate: {
        type: Boolean,
        default: false
      },
      showMostPopularCount: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        guides: [],
        filters: {
          page: 0
        },
        count: 0,
        page: 1,
        max_count: 5,
        max_pages: 2,
        hasMore: false,
        loaded: false,
        loading: true,
        urls
      }
    },
    mounted () {
      this.filters = {
        sort_by: this.filter,
        page: this.page,
      }
      if (this.user) {
        this.filters.user = true;
      }
      this.loadGuides()
    },
    methods: {
      async loadGuides () {
        this.loading = true
        let guidesData = await getGuides(this.filters)
        this.count = guidesData.data.count
        this.guides = guidesData.data.data
        this.hasMore = guidesData.data.has_more
        this.loading = false
        this.loaded = true
      },

      loadMore () {
        this.filters.page++
        this.loadGuides()
      },

      createdAt (date) {
        return formatDate(date, 'MMM d')
      }
    }
  }
</script>
